import { render, staticRenderFns } from "./parent.vue?vue&type=template&id=bccad64a"
import script from "./parent.vue?vue&type=script&lang=js"
export * from "./parent.vue?vue&type=script&lang=js"
import style0 from "./parent.vue?vue&type=style&index=0&id=bccad64a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports